module.exports = __webpack_public_path__ + "static/tokr-web-7c105eb061e585bc7a80e8ec22b71ff4.jpg";